import isEqual from 'react-fast-compare';

import {BulkAssemblyActionType} from 'molbio/bulk-assembly/BulkAssemblyActions';
import {BulkAssemblyProcedure} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {AsyncBulkAssemblyValidationResults} from 'molbio/bulk-assembly/BulkAssemblyValidationConstants';
import {ValidationStatus} from 'molbio/bulk-assembly/BulkAssemblyValidationConstants';
import {BenchlingAction} from 'redux-stores/Action';
import {AsyncState, AsyncStatus, getMostRecentData} from 'ui-library/hooks/useAsyncState';

export interface BulkAssemblyState {
  procedure: BulkAssemblyProcedure;
  asyncState: AsyncState<AsyncBulkAssemblyValidationResults, BulkAssemblyProcedure>;
  fragmentStatusFilter: ValidationStatus | null;
  constructStatusFilter: ValidationStatus | null;
}

export default function reduceBulkAssembly(
  state: BulkAssemblyState,
  action: BenchlingAction
): BulkAssemblyState {
  switch (action.type) {
    case BulkAssemblyActionType.BULK_ASSEMBLY_STATE_UPDATED:
      if (isEqual(action.procedure, state.procedure)) {
        return state;
      }
      return {...state, procedure: action.procedure};
    case BulkAssemblyActionType.BULK_ASSEMBLY_VALIDATION_STARTED:
      return {
        ...state,
        asyncState: {
          status: AsyncStatus.LOADING,
          previousData: getMostRecentData(state.asyncState),
          input: action.input,
        },
      };
    case BulkAssemblyActionType.BULK_ASSEMBLY_VALIDATION_COMPLETED:
      return {
        ...state,
        asyncState: {
          status: AsyncStatus.SUCCESS,
          data: action.data,
          input: state.asyncState.status === AsyncStatus.LOADING ? state.asyncState.input : undefined,
        },
      };
    case BulkAssemblyActionType.BULK_ASSEMBLY_VALIDATION_FAILED:
      return {
        ...state,
        asyncState: {
          status: AsyncStatus.ERROR,
          message: action.message,
          responseJSON: action.responseJSON,
        },
      };
    case BulkAssemblyActionType.BULK_ASSEMBLY_FRAGMENT_STATUS_FILTER_UPDATED:
      return {...state, fragmentStatusFilter: action.statusFilter};
    case BulkAssemblyActionType.BULK_ASSEMBLY_CONSTRUCT_STATUS_FILTER_UPDATED:
      return {...state, constructStatusFilter: action.statusFilter};
    default:
      return state;
  }
}
